import { useRouter } from 'next/router';

import JointCertificateInstallView from '@/components/tax-refund/common/view/JointCertificateInstallView';
import { 환급결정확인알림톡_PATH } from '@/lib/constants/paths';

const ResultJointCertificateInstallContent = () => {
  const router = useRouter();

  const moveJointCertificateSelectPage = () => {
    router.replace({
      pathname: `${환급결정확인알림톡_PATH.공동인증서선택}`,
      query: router.query
    });
  };

  return (
    <JointCertificateInstallView
      viewController={{
        moveJointCertificateSelectPage
      }}
    />
  );
};

export default ResultJointCertificateInstallContent;
